import { Box, Typography } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'components/SearchBar/SearchOption/components/SearchOptionTitle/SearchOptionTitle.styles';
import { IFormattedSearch } from 'components/SearchBar/SearchOption/types/IFormattedSearch';
import { highlightPartialMatch } from 'components/SearchBar/SearchOption/utils/highlightMatch';

type SearchOptionTitleProps = {
  option: IFormattedSearch;
  inputValue: string;
};

const SearchOptionTitle = ({ option, inputValue }: SearchOptionTitleProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="body2">{highlightPartialMatch(option.spaceId, inputValue)}</Typography>
      <Box className={classes.divider} data-testid="divider" />
      <Typography variant="body2">{highlightPartialMatch(option.name, inputValue)}</Typography>
    </Box>
  );
};

export default SearchOptionTitle;
